import React from 'react';
import PropTypes from 'prop-types';

import { Row, Col } from 'reactstrap';
import CarItem from '../CarItem';
import './styles.scss';

const index = props => {
  const { cars, selectedFilters } = props;
  const isCatalogoFilterSelected = selectedFilters.some(selectedFilter => selectedFilter.value === 'catalogo');
  const carsTpl = cars.map((offer, key) => {
    let link = `/offers/${offer.code}?duration=${offer.duration}&deposit=${offer.deposit}&distance=${offer.distance}`;

    if (offer.bundle && offer.bundle.trim() !== '') {
      link += `&bundle=${offer.bundle}`;
    }

    return <Col md={4} xs={12} key={key}>
      <CarItem
        image={offer.image}
        brand={offer.brand}
        model={offer.model}
        reference_code={offer.reference_code}
        version={offer.version}
        target={offer.code}
        monthlyRate={offer.monthly_rate}
        deposit={offer.deposit}
        duration={offer.duration}
        distance={offer.distance}
        bundle={offer.bundle}
        tag={offer.tag}
        secondary_tag={offer.secondaryTag}
        stockAvailability={offer.stockAvailability}
        delivery_time_label={offer.delivery_time_label}
        catalogSelected={isCatalogoFilterSelected}
        color={offer.color}
        highlighted={offer.isHighlighted}
        suggested={offer.isSuggested}
        sustainabilityIndex={offer.sustainabilityIndex}
        link={link}
        isCustom={offer.isCustom}
        isOwned={offer.isOwned}
      />
    </Col>
  });

  return (
    <div className="CarItemsList">
      <Row>{carsTpl}</Row>
    </div>
  );
};

index.propTypes = {
  cars: PropTypes.any.isRequired,
};

export default index;
